import { render, staticRenderFns } from "./GnPage.vue?vue&type=template&id=ca3d394e&scoped=true&"
import script from "./GnPage.vue?vue&type=script&lang=js&"
export * from "./GnPage.vue?vue&type=script&lang=js&"
import style0 from "./GnPage.vue?vue&type=style&index=0&id=ca3d394e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3d394e",
  null
  
)

export default component.exports